module.exports = __webpack_public_path__ + "static/media/like.1a097022.png";